const baseUrl = process.env.NEXT_PUBLIC_BASE_URL

export const getPanel = async ({ slug, localeValue, language, limit, page }) => {



    const url = `${baseUrl}/content/search/${slug}?page=${page}&limit=${limit}`
    const headers = {
        'apikey': process.env.NEXT_PUBLIC_RSTBASE_API_KEY,
        'locale': localeValue || 'en'
    }

    const isProd = process.env.NODE_ENV === 'production'

    const response = await fetch(url, {
        headers: headers,
            ...(isProd
        ? { next: { revalidate: 900 } }
        : { cache: 'no-store' }),
    })

    const result = await response.json()

    // console.log(result)
    
    return result

}